exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-b60a7f26]{padding:0 2rem}[data-v-b60a7f26] .plugin-wrapper .item-master{margin:0 10px}", ""]);

// exports
